var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMutualFund = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#1072BA",
  fillOpacity: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.1516 9.02V16H12.7516V11.46L10.8816 16H9.82156L7.94156 11.46V16H6.54156V9.02H8.13156L10.3516 14.21L12.5716 9.02H14.1516ZM19.8457 9.02V10.15H16.9357V11.94H19.1657V13.05H16.9357V16H15.5357V9.02H19.8457Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMutualFund);
export { ForwardRef as ReactComponent };